import React, { Component } from 'react';
import PreviewModal from './prerender';
import { Provider } from 'react-redux';
import { store } from '../globals';
import lpApp from '../app/lp_app';
import queryString from 'query-string';

export default class PreviewModalWrapper extends Component {
    constructor(props) {
        super(props)
        const {uniqid, doc} = queryString.parse(this.props.location.search)
        lpApp.callbacks.setupInitialCallbacks();
        lpApp.mainPrerender(uniqid, doc);
    }

    render() {
        return (<Provider store={ store }>
            <div>
              <PreviewModal />
            </div>
          </Provider>); 
    }
}



// WEBPACK FOOTER //
// ./src/components/preview_modal_wrapper.js